import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { DefaultDataCronogramaSGQ } from "../../../../../../common/components/default_data_prevista_CronogramaSGQ";
import DefaultInput from "../../../../../../common/components/default_input";
import { DefaultDataProvisaoRecurso } from "../../../../../../common/components/default_data_provisao_recurso";

// Header 

type Props = {
  tipoPesquisa: number,
  pesquisa: string | Date | number | null,
  onClearFilters: () => void;
  handleTipoPesquisa: (v: number) => void,
  handlePesquisa: (v: string | Date | number | null) => void,
};

export const Header = ({ tipoPesquisa, pesquisa, handlePesquisa, handleTipoPesquisa, onClearFilters }: Props) => {
  
  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);

  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full flex flex-col gap-6">
        <div className="w-full grid gap-3 grid-cols-1 md:grid-cols-[275px,1fr,220px]">
          <div className="flex gap-1">
            <FormControl size="small" sx={{ width: "275px" }}>
              <InputLabel id="modulo-dashboard" size="small">Pesquisar por</InputLabel>
              <Select
                size="small"
                labelId="modulo-dashboard"
                label="Pesquisar por"
                value={tipoPesquisa}
                onChange={(event: SelectChangeEvent<number>) => {
                  handlePesquisa("");
                  handleTipoPesquisa(event.target.value as number)
                }}>
                <MenuItem value={0}>Ano</MenuItem>
                <MenuItem value={1}>Recurso</MenuItem>
              </Select>
            </FormControl>
          </div>

          <div className="w-full">
            {(tipoPesquisa === 0) ? (
              <DefaultDataProvisaoRecurso
                key={tipoPesquisa} 
                name="Pesquisar"
                value={typeof pesquisa === 'number' ? pesquisa : null}
                onChange={(valor) => handlePesquisa(valor ?? "")}
              />
            ) : (tipoPesquisa === 1) 
            ? (
            <DefaultInput
              label="Pesquisar"
              name="search_by_name"
              value={String(pesquisa)?? ""}
              onChangeValue={handlePesquisa}
            />) : (<></>)}

          </div>
          {/* Botão Limpar */}
          <div className="w-full flex justify-end md:col-span-3">
            <div className="w-full md:w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={handleClearFilters}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>

        </div>
      </div>
    </CascateList>
  );
}